import { ModuleWithProviders, NgModule } from '@angular/core';

import { JsonDateConfig, JsonDateInjectConfig } from './json-date.config';
import { jsonDateInterceptorFn } from './json-date.interceptor';

@NgModule({})
export class JsonDateModule {
  public static configure(
    config: JsonDateConfig,
  ): ModuleWithProviders<JsonDateModule> {
    return {
      ngModule: JsonDateModule,
      providers: [{ provide: JsonDateInjectConfig, useValue: config }],
    };
  }
}

export { jsonDateInterceptorFn };
